import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doSignOut } from "../../firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import "./myprofile.css";
import axios from "axios"; // Import axios

function App() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleCancelSubscription = () => {
    if (window.confirm("Are you sure you want to cancel your subscription?")) {
      if (user) {
        axios
          .post("https://supremebot-image-latest.onrender.com/cancel-subscription", {
            email: user.email,
          })
          .then((response) => {
            console.log("Subscription canceled:", response.data);
  
            // ✅ Show success message
            alert("You have successfully canceled your subscription.");
  
          })
          .catch((error) => {
            console.error("Error canceling subscription:", error);
            alert("There was an issue canceling your subscription. Please try again.");
          });
      }
    }
  };
  

  return (
    <div className="app-container" style={{ paddingTop: "200px" }}>
      {user ? (
        <div>
          <h1>Welcome, {user.email}!</h1>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Link to="/change">
              <button className="nav-button">Change Password</button>
            </Link>

            <button
              onClick={() => {
                doSignOut().then(() => {
                  navigate("/login");
                });
              }}
              className="nav-button"
              style={{ width: "fit-content" }}
            >
              Logout
            </button>

            {/* <button
              onClick={handleCancelSubscription}
              className="nav-button"
              style={{ width: "fit-content" }}
            >
              Cancel Subscription
            </button> */}

            <p style={{ fontSize: "12px", color: "gray", marginTop: "20px" }}>
              *No refunds.*
            </p>

          </div>
        </div>
      ) : (
        <div>
          <p>Please log in to view your email address.</p>
        </div>
      )}
    </div>
  );
}

export default App;